var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    viewBox: "0 0 597.17 365.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#091731;}.cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.22,164.78l-16.3,4.72c-21.1,5.87-38.24,9.76-51.4,9.76-38.24,0-57.72-22.65-57.72-69.91C47.8,61.72,67.28,39,105.52,39c13.16,0,30.3,4.33,51.4,9.77l16.3,4.73V13.39l-10.33-2.85C139.4,3.91,119.07,0,101.17,0,41,0,0,37.49,0,109.35,0,184,41,218.72,101.17,218.72c17.9,0,38.23-4.31,61.72-10.92l10.33-2.88Zm423.95,0-16.29,4.72c-21.12,5.87-38.25,9.76-51.41,9.76-38.24,0-57.72-22.65-57.72-69.91,0-47.63,19.48-70.31,57.72-70.31,13.16,0,30.29,4.33,51.41,9.77l16.29,4.73V13.39l-10.33-2.85C563.35,3.91,543,0,525.12,0,465,0,424,37.49,424,109.35c0,74.6,41,109.37,101.17,109.37,17.9,0,38.23-4.31,61.72-10.92l10.33-2.88Zm-200.89,39V.51C389.74,1.9,383,3.64,375.89,5.81c-17.93,5.72-27.5,14.71-27.5,33.49V58.47l0,.06V215.91h35.52A12.27,12.27,0,0,0,396.28,203.77Zm-83.35,12.14a12.26,12.26,0,0,0,12.37-12.14V79.32l0,0V60.11c0-18.79-9.59-27.78-27.49-33.5-7.08-2.16-13.86-3.89-20.41-5.29V215.91Zm-70.7,0a12.26,12.26,0,0,0,12.37-12.14V79.32l0,0V60.11c0-18.79-9.59-27.78-27.49-33.5-7.08-2.16-13.85-3.89-20.4-5.29V215.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.07,
    y: 270.1,
    width: 12.98,
    height: 93.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.84,363.33H89.06V306.19c0-7.52-.77-19.67-.77-19.67h.26s6.24,11.4,10.82,18.42l38.69,58.39h13.49V270.1H139.33v57c0,7.77.89,19.93.89,19.93h-.38s-6-11.65-10.56-18.55L90.46,270.1H76.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.33,363.33h14.26l33.09-93.23H257.19L236.7,332.25c-2.17,6.52-5.48,19.93-5.48,19.93H231s-3.31-13.16-5.6-19.93L204.63,270.1h-14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.61 363.33 378.34 363.33 378.34 351.68 322.59 351.68 322.59 320.22 371.72 320.22 371.72 309.57 322.59 309.57 322.59 281.38 376.94 281.38 376.94 270.1 309.61 270.1 309.61 363.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.84,365.21c20.49,0,35.25-9.9,35.25-27.57,0-20.8-16.67-25.44-35-29.07-14.25-2.88-24.56-5.76-24.56-15.91,0-9.28,8.14-14.29,20.62-14.29,13.36,0,21.63,6.14,23.29,17.42H487c-2.3-15.92-12.73-27.44-36-27.44-19.47,0-32.84,9.27-32.84,24.93,0,17.92,14.38,22.68,31.31,26.19C466,323.11,477,326,477,338.14c0,11.28-9.16,16.79-21.76,16.79-17.18,0-26.6-7.77-28.13-21.8H414.24C415.26,350.92,428.36,365.21,454.84,365.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "521.82 281.38 552.88 281.38 552.88 363.33 565.99 363.33 565.99 281.38 597.17 281.38 597.17 270.1 521.82 270.1 521.82 281.38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavy);
export default __webpack_public_path__ + "static/media/navy.4c75b11b95b6db0ecb435d58e1a6d0ce.svg";
export { ForwardRef as ReactComponent };